
// H2O Card Enhancements - Badges + What's Included dropdowns
// Also fixes Luxe image CDN cache issue
(function() {
  'use strict';

  // Fix Luxe image (Shopify CDN cache issue - old image was deleted)
  function fixLuxeImage() {
    const oldSrc = 'h2o-luxe-v4';
    const newSrc = 'https://cdn.shopify.com/s/files/1/0948/8623/2395/files/h2o-luxe-our-most-popular.png?v=1773234232';
    
    document.querySelectorAll('img').forEach(img => {
      if (img.src && img.src.includes(oldSrc)) {
        const width = img.width || 533;
        img.src = newSrc + '&width=' + width;
        img.srcset = [165, 360, 533, 720, 940, 1066].map(w => newSrc + '&width=' + w + ' ' + w + 'w').join(',');
      }
    });
  }

  // What's Included data
  var packages = {
    'ultra': {
      badge: null,
      tagline: 'THE ULTIMATE PAMPER',
      items: [
        'Full Interior Deep Clean',
        'Leather Treatment & Conditioning',
        'Full Dashboard & Console Detail',
        'Air Freshener Treatment',
        'Door Shuts & Sills Cleaned',
        'Boot Vacuum & Wipe Down',
        'Full Exterior Hand Wash',
        'Alloy Wheel Deep Clean',
        'Tyre Dressing',
        'Clay Bar Paint Decontamination',
        'Machine Polish (Single Stage)',
        'Paint Sealant Protection',
        'Glass Polish & Rain Repellent',
        'Exhaust Tip Polish'
      ]
    },
    'luxe': {
      badge: 'OUR MOST POPULAR',
      tagline: null,
      items: [
        'Full Interior Vacuum',
        'Dashboard & Console Wipe',
        'Leather Seat Wipe Down',
        'Air Freshener',
        'Door Shuts Cleaned',
        'Boot Vacuum',
        'Full Exterior Hand Wash',
        'Alloy Wheel Clean',
        'Tyre Dressing',
        'Tar & Iron Removal',
        'Spray Wax Finish',
        'Glass Clean Inside & Out'
      ]
    },
    'premium': {
      badge: null,
      tagline: 'YOUR CAR WILL THANK YOU',
      items: [
        'Interior Vacuum',
        'Dashboard Wipe',
        'Air Freshener',
        'Full Exterior Hand Wash',
        'Alloy Wheel Rinse',
        'Tyre Dressing',
        'Spray Wax Finish',
        'Window Clean (Exterior)',
        'Door Shuts Wiped'
      ]
    }
  };

  function addEnhancements() {
    var cards = document.querySelectorAll('.card-wrapper');
    
    cards.forEach(function(card) {
      // Skip if already enhanced
      if (card.querySelector('.h2o-whats-included')) return;
      
      var heading = card.querySelector('.card__heading');
      if (!heading) return;
      var title = heading.textContent.toLowerCase();
      
      var pkg = null;
      if (title.includes('ultra')) pkg = packages['ultra'];
      else if (title.includes('luxe')) pkg = packages['luxe'];
      else if (title.includes('premium')) pkg = packages['premium'];
      
      if (!pkg) return;
      
      // Find the card-information div (where title and price are)
      var cardInfo = card.querySelector('.card-information');
      if (!cardInfo) return;
      
      // Create container
      var container = document.createElement('div');
      container.className = 'h2o-whats-included';
      container.style.cssText = 'margin-top: 8px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;';
      
      // Add badge if applicable
      if (pkg.badge) {
        var badge = document.createElement('div');
        badge.style.cssText = 'display: inline-flex; align-items: center; gap: 4px; background: #00BCD4; color: white; font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 3px; margin-bottom: 6px; letter-spacing: 0.5px;';
        badge.innerHTML = '⭐ ' + pkg.badge;
        container.appendChild(badge);
      }
      
      // Add What's Included dropdown
      var details = document.createElement('details');
      details.style.cssText = 'border: 1px solid #e0e0e0; border-radius: 6px; overflow: hidden;';
      
      var summary = document.createElement('summary');
      summary.style.cssText = 'display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; cursor: pointer; font-size: 13px; font-weight: 600; color: #1a1a2e; background: #f8f9fa; list-style: none; user-select: none;';
      summary.innerHTML = "What's Included? <span style='font-size: 16px; transition: transform 0.2s;'>+</span>";
      
      // Toggle + / - on open/close
      details.addEventListener('toggle', function() {
        var icon = summary.querySelector('span');
        icon.textContent = details.open ? '−' : '+';
      });
      
      var content = document.createElement('div');
      content.style.cssText = 'padding: 8px 12px; background: white;';
      
      var ul = document.createElement('ul');
      ul.style.cssText = 'list-style: none; padding: 0; margin: 0;';
      
      pkg.items.forEach(function(item) {
        var li = document.createElement('li');
        li.style.cssText = 'padding: 3px 0; font-size: 12px; color: #444; border-bottom: 1px solid #f0f0f0; display: flex; align-items: center; gap: 6px;';
        li.innerHTML = '<span style="color: #00BCD4; font-size: 11px;">✓</span> ' + item;
        ul.appendChild(li);
      });
      
      content.appendChild(ul);
      details.appendChild(summary);
      details.appendChild(content);
      container.appendChild(details);
      
      cardInfo.appendChild(container);
    });
  }

  // Run on DOM ready and after delays for lazy loading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      fixLuxeImage();
      addEnhancements();
      setTimeout(fixLuxeImage, 500);
      setTimeout(addEnhancements, 500);
      setTimeout(fixLuxeImage, 1500);
    });
  } else {
    fixLuxeImage();
    addEnhancements();
    setTimeout(fixLuxeImage, 500);
    setTimeout(addEnhancements, 500);
    setTimeout(fixLuxeImage, 1500);
  }

  // Observe for dynamic section rendering
  var observer = new MutationObserver(function() {
    fixLuxeImage();
    addEnhancements();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 15000);
})();
